<template>
    <div>
      <MetaManager
        title="View All Incentives "
        description="Explore Stark Shopper for a comprehensive selection of incentives. View by category or see all available offers to find the best savings today"
      />
      <div class="browse-all-deals">
        <CategoryFilter :categories="categories" @category-selected="filterCoupons" :default-category="'all'" />
      </div>
      <div class="coupon-list">
        <CouponCard
            v-for="coupon in displayedCoupons"
            :key="coupon._id"
            :couponId="coupon._id"
            :dealTitle="coupon.dealtitle"
            :couponCode="coupon.couponcode[0]"
            :couponImage="coupon.image_links[0]"
            :rating="formatRating(coupon.rating)"
            :category="coupon.category"
            :businessName="coupon.business_name"
            :businessAddress="coupon.address"
            :businessLogo="coupon.business_logo"
            @save-coupon="addToShoppingCart"
            ref="couponCards"
        />
      </div>
      <div class="load-more-container" v-if="!allCouponsLoaded">
        <button @click="loadMoreCoupons">Load More Incentives</button>
      </div>
    </div>
  </template>
  
  <script>
  import CouponCard from '@/components/Coupon Components/CouponCard.vue';
  import CategoryFilter from '@/components/Frontend Nav Components/CategoryFilterBar.vue';
  import axios from 'axios';
  import MetaManager from '../../components/MetaManager.vue';
  
  export default {
    components: {
      CategoryFilter,
      CouponCard,
      MetaManager,
    },
    data() {
      return {
        categories: [
          { id: 'all', name: 'All' },
          { id: 'Restaurants', name: 'Restaurants' },
          { id: 'Beauty-spa', name: 'Beauty & Spas' },
          { id: 'Things-to-do', name: 'Things to do' },
          { id: 'Health-fitness', name: 'Health & Fitness' },
          { id: 'Automotive', name: 'Automotive' },
          { id: 'Home-services', name: 'Home Services' },
          { id: 'Retail', name: 'Retail' },
          { id: 'Technology', name: 'Technology' },
          { id: 'Other', name: 'Other' }
        ],
        coupons: [],
        displayedCoupons: [],
        selectedCategory: 'all',
        selectedLocation: localStorage.getItem('selectedLocation') || 'Stark County, Ohio',
        offset: 0,
        limit: 20,
        allCouponsLoaded: false,
      };
    },
    methods: {
      async loadCoupons(reset = false) {
        try {
            if (reset) {
            this.coupons = [];
            this.offset = 0;
            this.allCouponsLoaded = false;
            }
            const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/data`, {
            params: {
                limit: this.limit,
                offset: this.offset,
                category: this.selectedCategory === 'all' ? '' : this.selectedCategory,
                location: this.selectedLocation,
            }
            });
            const newCoupons = response.data;
            if (reset) {
            this.coupons = newCoupons;
            } else {
            this.coupons = [...this.coupons, ...newCoupons];
            }
            this.allCouponsLoaded = newCoupons.length < this.limit;
            if (newCoupons.length > 0) {
            this.offset += this.limit; // Move the offset forward only if there are new coupons
            }
            this.updateDisplayedCoupons();
        } catch (error) {
            console.error('Error fetching coupons:', error);
            // Clear coupons array to avoid showing old data
            if (reset) {
              this.coupons = [];
              this.displayedCoupons = [];
            }
        }
      },
      formatRating(rating) {
        if (rating === null || rating === undefined) return '0.00';
        return Number(rating).toFixed(1);
      },
      loadMoreCoupons() {
        this.loadCoupons();
      },
      filterCoupons(category) {
        this.selectedCategory = category.id;
        this.loadCoupons(true);
        this.$nextTick(() => {
          const el = document.querySelector('.coupon-list');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      },
      updateDisplayedCoupons() {
        this.displayedCoupons = this.coupons;
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // Smooth scrolling
        });
      },
      processDiscount(coupon) {
        const { discount, regularprice, spendamount, discounttype } = coupon;
        const isRegularPriceValid = regularprice[0] !== 0;
        const isSpendAmountValid = spendamount[0] !== 0;
  
        return {
          discount: discount[0],
          regularprice: isRegularPriceValid ? regularprice : null,
          spendamount: isSpendAmountValid ? spendamount : null,
          discounttype: discounttype[0]
        };
      },
      async addToShoppingCart(couponId) {
        const userId = this.getUserId();
        try {
          await axios.post(`${process.env.VUE_APP_API_URL}/api/shoppingCart/${userId}`, { couponId });
          this.$refs.couponCards.forEach(card => {
            if (card.couponId === couponId) {
              card.showMessage('Coupon added to saved coupons');
            }
          });
        } catch (error) {
          if (error.response && error.response.status === 400) {
            this.$refs.couponCards.forEach(card => {
              if (card.couponId === couponId) {
                card.showMessage('Coupon already saved');
              }
            });
          } else {
            this.$refs.couponCards.forEach(card => {
              if (card.couponId === couponId) {
                card.showMessage('Error adding coupon to shopping cart');
              }
            });
          }
        }
      },
      getUserId() {
        const user = JSON.parse(localStorage.getItem('user'));
        return user ? user.id : null;
      }
    },
    mounted(){
      this.scrollToTop();
      this.loadCoupons();
      
      // Listen for location changes from the navbar
      window.addEventListener('location-changed', (event) => {
        // Update the selectedLocation from localStorage
        this.selectedLocation = event.detail.location;
        this.loadCoupons(true); // Reload coupons with new location
      });
    }
  };
  </script>
  
  <style scoped>
   .coupon-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px; 
    justify-content: center; 
    margin: 0 auto;
    max-width: 800px;
    padding-left: 8%;
    margin-bottom: 20px;
    font-family: 'Roboto', sans-serif;
  }

  .coupon-list :deep(.coupon-card) {
    margin-bottom: 30px;
    gap: 15px;
  }

  .coupon-item {
    width: 100%; 
    max-width: 600px;
  }
  
  .browse-all-deals {
    text-align: left;
    margin-left: 7%;
    margin-top: 50px;
    padding-bottom: 20px;
    font-family: 'Roboto', sans-serif;
  }
  
  .load-more-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  button {
  padding: 15px 25px;
  font-size: 16px;
  cursor: pointer;
  background-color: #4C6B30;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 17px;
  margin-bottom: 50px;
}

button:hover {
  background-color: #6E9F49;
}

.coupon-list :deep(.coupon-card) {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.coupon-list :deep(.coupon-card:hover) {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 1200px) {
    .coupon-list {
      grid-template-columns: repeat(2, 1fr); 
      gap: 10px; 
      justify-content: center; 
    }
    .coupon-item {
      width: 100%; 
      max-width: 600px; 
    }
  }

@media (max-width: 1024px){
  .browse-all-deals{
    margin-top: 25%;
    margin-left: 0%;
  }
  .coupon-list {
    grid-template-columns: repeat(2, 1fr); 
    gap: 10px; 
    justify-content: center; 
  }
  .coupon-item {
    width: 100%; 
    max-width: 600px; 
  }
}
  
  @media (max-width: 768px) {
    .browse-all-deals {
      margin-left: 5%;
      margin-top: 10px;
      padding-bottom: 10px;
      margin-bottom: 150px;
    }
  
    button {
      padding: 8px 16px; 
      font-size: 14px; 
    }

    .coupon-list .coupon-item {
      flex-direction: column;
      align-items: center;
  }

  .coupon-list :deep(.coupon-card:hover) {
    transform: translateY(-3px);
  }

  .coupon-list {
    grid-template-columns: 1fr;
    gap: 10px; 
    justify-content: center;
  }
  .coupon-item {
    width: 100%;
    max-width: 600px;
  }
  }
  
  @media (max-width: 480px) {
    .coupon-list {
      flex-direction: column;
      align-items: center;
    }
  
    .browse-all-deals {
      margin-left: 9%;
      padding-bottom: 5px;
    }
  
    .load-more-container {
      margin-bottom: 10px; 
    }
  
    button {
      padding: 6px 12px;
      font-size: 12px; 
    }

    .coupon-list .coupon-item {
    flex-basis: calc(50% - 20px); 
  }

  .coupon-list :deep(.coupon-card:hover) {
    transform: translateY(-2px);
  }
  }
  </style>
